
import { defineComponent } from "vue";

export default defineComponent({
  name: "BaseInput",
  props: {
    label: {
      type: String,
      default: "",
    },
    modelValue: {
      type: [String, Number],
      default: "",
    },
  },
  emits: ["update:modelValue"],
  setup(_, context) {
    const updateInput = (evt: Event) => {
      context.emit("update:modelValue", (evt.target as HTMLInputElement).value);
    };

    return {
      updateInput,
    };
  },
});
